import { toast } from 'react-toastify';
import { CollectionApiError, FieldError } from '../../../../services/collectionApi';

export const reportCollectionError = (
    error: unknown,
    fallback: string,
    onFieldErrors: (fieldErrors: FieldError[]) => void = () => undefined,
) => {
    if (error instanceof CollectionApiError) {
        if (error.status === 422) onFieldErrors(error.fieldErrors);
        toast.error(error.message || (error.status === 422 ? 'Há campos inválidos!' : fallback));
        return;
    }
    toast.error(fallback);
};
